export enum EPeriodo {
    Hoje = 1,
    MesAtual = 2,
    Ultimos7Dias = 3,
    Ultimos15Dias = 4,
    Ultimos60Dias = 5,
    Ultimos90Dias = 6,
    Personalizado = 7,
}
